<div *ngIf="!data" class="alert alert-info">Loading...please wait...</div>

<div *ngIf="data" style="background-color: red;">
    <!--    <pdf-viewer [src]="pdfSrc"-->
    <!--                [render-text]="true"-->
    <!--                style="display: block; "-->
    <!--                (error)="onError($event)"-->
    <!--    ></pdf-viewer>-->


    <ngx-extended-pdf-viewer
            [base64Src]="data"
            backgroundColor="#ffffff"
            [height]="'90vh'"
            [useBrowserLocale]="true"
            [handTool]="false"
            [showHandToolButton]="true"
            [backgroundColor]="pdfBackgroundColor"
    >
    </ngx-extended-pdf-viewer>
</div>

